<template>
  <div
    role="alert"
    aria-live="polite"
    aria-atomic="true"
    class="alert" :class="tip"
  >
    <h4 class="alert-heading">{{ title }}</h4>
    <p>{{ text }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
        v: {
      type: Object,
    },
      

      
    };
  },props: {
        text: {default: "dfas"},
        title: {default: "dfas"},
        tip: { default: "alert-success"}
      },
};
</script>
